import { useMessages, useLocale } from '@/i18n/LocaleProvider';
import messages from '@/i18n/catalogs/corporate/SocialProofWidget';
import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Github, Download, Users } from 'lucide-react';
import { invokeFunction } from '@/integrations/supabase/invoke';

const SocialProofWidget = () => {
  const m = useMessages(messages);
  const { formatLocale } = useLocale();


  const [githubStars, setGithubStars] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    // Star count comes from our cached github-stats proxy (avoids the browser hitting
    // GitHub's rate limit and logging 403s). Fall back to a reasonable number on error.
    invokeFunction('github-stats')
      .then(({ data, error }) => {
        if (cancelled) return;
        setGithubStars(!error && typeof data?.stars === 'number' ? data.stars : 350);
      })
      .catch(() => {
        if (!cancelled) setGithubStars(350);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const stats = [
    {
      icon: Github,
      label: m.s1,
      value: githubStars !== null ? githubStars.toLocaleString(formatLocale) : null,
      color: 'text-purple-600 dark:text-purple-400',
    },
    {
      icon: Download,
      label: m.s2,
      value: m.pulls,
      color: 'text-blue-600 dark:text-blue-400',
    },
  ];

  return (
    <section className="py-16 bg-muted/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center border-border">
              <CardContent className="p-6">
                <stat.icon className={`h-8 w-8 mx-auto mb-2 ${stat.color}`} />
                {stat.value !== null ? (
                  <div className="text-2xl font-bold mb-1">{stat.value}</div>
                ) : (
                  <div className="h-8 w-16 mx-auto mb-1 bg-muted animate-pulse rounded" />
                )}
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofWidget;
